import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import FormatUtils from '../common/formatUtils/FormatUtils';
import DateFormat from '../common/dateFormat/DateFormat';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'VEICULO_DOCUMENTO_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}
export function initForm(registro = {}) {
    return [
        initialize('veiculoDocumentoForm', registro)
    ];
}

export function getLista() {
    const request = axios.get(`${consts.API_URL}/veiculoDocumento`);
    return {
        type: 'VEICULO_DOCUMENTO_LISTADO',
        payload: request
    };
}

export function salvar(registro) {
    return (dispatch, getState) => {

        let tipo = getState().veiculoDocumento.listaTipo.filter(tipo => tipo.id == registro.id_tipo)[0] || {};

		if (!registro.id) {
	        axios.post(`${consts.API_URL}/veiculoDocumento`, {
                ...registro,
                data_documento: DateFormat.formatarDataTelaParaSql(registro.data_documento),
                data_vencimento: DateFormat.formatarDataTelaParaSql(registro.data_vencimento),
                data_programacao: DateFormat.formatarDataTelaParaSql(registro.data_programacao),                
                obriga_data: tipo.obriga_data,
                obriga_vencimento: tipo.obriga_vencimento,
                obriga_programacao: tipo.obriga_programacao,
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_URL}/veiculoDocumento`, {
                ...registro,
                data_documento: DateFormat.formatarDataTelaParaSql(registro.data_documento),
                data_vencimento: DateFormat.formatarDataTelaParaSql(registro.data_vencimento),
                data_programacao: DateFormat.formatarDataTelaParaSql(registro.data_programacao),                
                obriga_data: tipo.obriga_data,
                obriga_vencimento: tipo.obriga_vencimento,
                obriga_programacao: tipo.obriga_programacao,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}

export function excluir(registro) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/veiculoDocumento?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function getListaVeiculo() {
    const request = axios.get(`${consts.API_URL}/veiculo/listarSelect`);
    return {
        type: 'VEICULO_DOCUMENTO_VEICULO_SELECT_LISTADO',
        payload: request
    };
}

export function getListaTipo() {
    const request = axios.get(`${consts.API_URL}/veiculoDocumentoTipo/listarSelect`);
    return {
        type: 'VEICULO_DOCUMENTO_TIPO_SELECT_LISTADO',
        payload: request
    };
}	